'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('rulesets.ctrls', [])
    .controller('TapIORuleSetController', TapIORuleSetController)
    .controller('RoutingRuleSetController', RoutingRuleSetController);

RoutingRuleSetController.$inject = ['$rootScope', '$scope', '$stateParams','UserService', 'ClusterService', 'DateRangeService', 'WorkflowService', '$modal', '$state', 'ModalService'];

function RoutingRuleSetController($rs, $scope, $stateParams, ClusterService,UserService, DateRangeService, WorkflowService, $modal, $state, ModalService) {
    var workflowId = $stateParams.id;
    $scope.ruleSets = [];
    $scope.workflowActions = [];

    var getRoutingRuleSetsList = function() {
        WorkflowService.getRoutingRuleSets(workflowId).then(function() {
            $scope.ruleSets = WorkflowService.routingRuleSets;
        }, function() {
            console.log("error loading routing rule sets list");
        })
    };

    var getWorkflowActions = function() {
        WorkflowService.getWorkflowActions().then(function() {
            $scope.workflowActions = WorkflowService.workflowActions;
        }, function() {
            console.log("error loading tasks list");
        });
    };

    function showModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.addNew = function(ruleSet) {
        $scope.isNew = (ruleSet == null);

        showModal('addRoutingRuleSet', {
            ruleSet: ruleSet,
            workflowActions: $scope.workflowActions
        }).result.then(function(formObj) {
            if ($scope.isNew) {
                WorkflowService.addRoutingRuleSet(formObj).then(function(data) {
                    $scope.ruleSets.push(data);
                }, function() {
                    console.log("error saving routing rule set");
                })
            } else {
                WorkflowService.updateRoutingRuleSet(formObj).then(function(data) {
                    console.log(data);
                }, function() {
                    console.log("error updating routing rule set");
                })
            }
        }, function() {
            console.log("cancel");
        })
    };

    $scope.backToList = function() {
        $state.go('workflows');
    };

    $scope.init = function() {
        //Cluster Selector currently does nothing on this page, disabling
        ClusterService.initCluster($rs.userRole, 'disabled');
        DateRangeService.init();
        getRoutingRuleSetsList();
        getWorkflowActions();
    };
    $scope.init();
}

TapIORuleSetController.$inject = ['$rootScope', '$scope', '$modal', 'ClusterService', 'DateRangeService', 'TapIoRuleSetService', '$ioAlert', '$confirm', 'ModalService', '$location', 'anchorSmoothScroll', '$timeout', 'FormService', 'UserService'];

function TapIORuleSetController($rs, $scope, $modal, ClusterService, DateRangeService, TapIoRuleSetService, $ioAlert, $confirm, ModalService, $location, anchorSmoothScroll, $timeout, FormService, UserService) {
    $scope.ruleSets = [];
    $scope.ruleOperationsList = [];
    $scope.ruleTargetsList = [];
    $scope.rulesListObj = {};
    $scope.disableBtnAction = false;

    var getRuleSetsList = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Rule Sets";
        TapIoRuleSetService.getRuleSets().then(function() {
            $scope.ruleSets = TapIoRuleSetService.ruleSets;
            $rs.loadingInProgress = false;
        }, function() {
            console.log("error loading ruleSets list");
            $rs.loadingInProgress = false;
        });
    };

    var getRuleOperations = function() {
        TapIoRuleSetService.getRuleOperations().then(function() {
            $scope.ruleOperationsList = TapIoRuleSetService.ruleOperationList;
        }, function() {
            console.log("error loading ruleSets list");
        });
    };

    function getRuleTargets() {
        TapIoRuleSetService.getRuleTargets().then(function () {
            $scope.ruleTargetsList = TapIoRuleSetService.ruleTargetsList;
        }, function () {
            console.log('error loading rule targets');
        });
    }


    function showModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    //Add Edit Rule Set
    $scope.addNewRuleSet = function(ruleSet) {
        $scope.isNew = (ruleSet == null);

        showModal('addRuleSet', {
            ruleSet: ruleSet
        }).result.then(function(formObj) {
            if ($scope.isNew) {
                TapIoRuleSetService.addRuleSet(formObj).then(function(data) {
                    if (data) {
                        $scope.ruleSets.push(data);
                        $ioAlert.show('', 'Rule Set Added successfully', 'success');
                        $location.hash('bottom-scroll');
                        anchorSmoothScroll.scrollTo('bottom-scroll');
                        $timeout(function() {
                            $location.hash('');
                        }, 1000);
                    }
                }, function() {
                    console.log("error saving TapIO rule set");
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            } else {
                TapIoRuleSetService.updateRuleSet(formObj).then(function(data) {
                    for (var i = 0, len = $scope.ruleSets.length; i < len; i++) {
                        if (data.id == $scope.ruleSets[i].id) {
                            $scope.ruleSets[i] = data;
                            $ioAlert.show('', 'TapIO Rule Set updated successfully', 'success');
                        }
                    }
                }, function() {
                    console.log("error updating routing rule set");
                })
            }
        }, function() {
            console.log("cancel");
        })
    };

    $scope.addRule = function(ruleSetId, rule) {
        var isNew = (rule == null);

        showModal('addRule', {
            ruleSetId: ruleSetId,
            rule: rule,
            ruleOperations: $scope.ruleOperationsList,
            ruleTargets: $scope.ruleTargetsList
        }).result.then(function(formObj) {
            if (isNew) {
                TapIoRuleSetService.addRule(formObj).then(function(data) {
                    if (data) {
                        if (!$scope.rulesListObj[ruleSetId]) {
                            $scope.rulesListObj[ruleSetId] = [];
                        }
                        $scope.rulesListObj[ruleSetId].push(data);
                        updateRuleOperations(ruleSetId);
                        $ioAlert.show('', 'Rule Added successfully', 'success');
                    }
                }, function() {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                TapIoRuleSetService.updateRule(formObj).then(function(data) {
                    if (data) {
                        for (var i = 0, len = $scope.rulesListObj[ruleSetId].length; i < len; i++) {
                            if (data.id == $scope.rulesListObj[ruleSetId][i].id) {
                                $scope.rulesListObj[ruleSetId][i] = data;
                                $ioAlert.show('', 'TapIO Rule Set updated successfully', 'success');
                            }
                        }
                        updateRuleOperations(ruleSetId);
                    }
                }, function() {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        }, function() {
            console.log("cancelled");
        });
    };

    $scope.deleteRule = function(ruleId, rule) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Rule?'
        }).then(function() {
            TapIoRuleSetService.deleteRule(ruleId).then(function() {
                for (var i = 0, len = $scope.rulesListObj[rule.rule_set_id].length; i < len; i++) {
                    if (ruleId == $scope.rulesListObj[rule.rule_set_id][i].id) {
                        $scope.rulesListObj[rule.rule_set_id][i] = [];
                        $ioAlert.show('Rule deleted', 'Rule has been successfully deleted', 'success');
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    $scope.deleteRuleSet = function(ruleSetId) {
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this Rule Set?'
        }).then(function() {
            TapIoRuleSetService.deleteRuleSet(ruleSetId).then(function(data) {
                if (data.errors) {
                    $ioAlert.show('Error!', data.errors[0], 'error');
                } else {
                    getRuleSetsList();
                    $ioAlert.show('Rule Set deleted', 'Rule Set has been successfully deleted', 'success');
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {})
    };

    var updateRuleOperations = function(ruleId) {
        for (var i = 0, len = $scope.rulesListObj[ruleId].length; i < len; i++) {
            for (var j = 0, size = $scope.ruleOperationsList.length; j < size; j++) {
                if ($scope.ruleOperationsList[j].id == $scope.rulesListObj[ruleId][i].rule_operation_id) {
                    $scope.rulesListObj[ruleId][i].rule_operation_name = $scope.ruleOperationsList[j].operation_value;
                }
            }
        }
    };

    $scope.toggle = function(ev, rule) {
        $(ev.target).siblings(':last').slideToggle(200);
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $scope.rulesListObj[rule.id] = [];
            TapIoRuleSetService.getRulesList(rule.id).then(function() {
                $scope.rulesListObj[rule.id] = TapIoRuleSetService.rulesList;
                updateRuleOperations(rule.id)
            }, function() {
                console.log("error loading rule list");
            });
        } else {
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
        }
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
    $scope.init = function() {
        //Cluster selector currently does nothing on this page, disabling
        ClusterService.initCluster($rs.userRole, 'hidden');
        DateRangeService.init();
        getRuleSetsList();
        getRuleOperations();
        getRuleTargets();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    $scope.init();
}